import { useEffect, useState } from "react";
import { createContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  deliverySuccessMessage,
  toastErrorMessage,
} from "../../../utils/toastMessage/toastMessage";
import {
  createReceptionOrderUserService,
  getReceptionInfoUserService,
} from "../../../services/userServices";
import { convertRoleToPath } from "../../../utils";

export const receptionInfoUserContext = createContext({
  products: [],
  setProducts: () => {},
  receptionInfo: {},
  setReceptionInfo: () => {},
  handleGetReceptionInfo: () => {},
  handleCreateOrder: () => {},
});

const ReceptionInfoUserContext = ({ children }) => {
  const auth = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const { pathname } = useLocation();
  const { id } = useParams();

  const [products, setProducts] = useState([]);
  const [receptionInfo, setReceptionInfo] = useState({});

  useEffect(() => {
    setProducts([]);
    setReceptionInfo({});
  }, [pathname]);

  // Get ReceptionInfo
  const handleGetReceptionInfo = async (event) => {
    event?.preventDefault();

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getReceptionInfoUserService(id);
      if (status === 200) {
        setReceptionInfo(data.result?.receptionInfo);

        const groupedProducts = data?.result?.products.reduce(
          (acc, product) => {
            const { _id, title } = product.category;

            if (!acc[_id]) {
              acc[_id] = {
                _id,
                title,
                products: [],
              };
            }

            acc[_id].products.push(product);

            return acc;
          },
          {}
        );

        setProducts(Object.values(groupedProducts));
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Create Order
  const handleCreateOrder = async (userData) => {
    const objData = {
      ...userData,
      id,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { data, status } = await createReceptionOrderUserService(objData);
      if (status === 200) {
        deliverySuccessMessage(
          data.resultMessage,
          `/${convertRoleToPath(auth.role)}/reception-orders`,
          "5000"
        );
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <receptionInfoUserContext.Provider
      value={{
        products,
        setProducts,
        receptionInfo,
        setReceptionInfo,
        handleGetReceptionInfo,
        handleCreateOrder,
      }}
    >
      {children}
    </receptionInfoUserContext.Provider>
  );
};

export default ReceptionInfoUserContext;
